import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import SearchResult from '../views/SearchResult.vue';
import RankingMore from '../views/RankingMore.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'SearchResult',
    component: SearchResult
  },
  {
    path: '/ranking-more',
    name: 'RankingMore',
    component: RankingMore
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
